import React, { useCallback, useRef, useState } from "react";
import { RETURN_METHOD_COMPLAINT, RETURN_METHOD_EXCHANGE, RETURN_METHOD_RETURN } from "~/constants";
import MethodSelector from "./MethodSelector";
import ReturnStepper from "./return/ReturnStepper";
import TurnrModal from "~/components/modals/TurnrModal";
import ComplaintStepper from "./complaint/ComplaintStepper";
import ExchangeStepper from "./exchange/ExchangeStepper";
import { isOnlyProductReturnEnabled } from "~/cores/productCore";

export default function ProductModal(props) {
    const { onSave, showModal, onModalClose, product, appProps } = props;

    const [exchangeMethodData, setExchangeMethodData] = useState();
    const [returnMethodData, setReturnMethodData] = useState();
    const [complaintMethodData, setComplaintMethodData] = useState();
    const [resaleMethodData, setResaleMethodData] = useState();

    const onlyReturnEnabled = isOnlyProductReturnEnabled(product, { appProps });

    const [returnMethod, setReturnMethod] = useState(onlyReturnEnabled ? RETURN_METHOD_RETURN : null);

    const isExchangeSelected = returnMethod === RETURN_METHOD_EXCHANGE;
    const isReturnSelected = returnMethod === RETURN_METHOD_RETURN;
    const isComplaintSelected = returnMethod === RETURN_METHOD_COMPLAINT;
    const methodRef = useRef();

    const backToMethodSelector = useCallback(() => {
        setReturnMethod(null);
    }, []);

    const contentProps = {
        ...props,
        ref: methodRef,
        resaleMethodData: resaleMethodData,
        setResaleMethodData: setResaleMethodData,
        exchangeMethodData: exchangeMethodData,
        setExchangeMethodData: setExchangeMethodData,
        complaintMethodData: complaintMethodData,
        setComplaintMethodData: setComplaintMethodData,
        returnMethodData: returnMethodData,
        setReturnMethodData: setReturnMethodData,
        onSave,
        onModalClose,
        backToMethodSelector,
        appProps,
    };

    return (
        <>
            <TurnrModal open={showModal} onClose={() => onModalClose()}>
                {product && (
                    <div>
                        {isReturnSelected && <ReturnStepper {...contentProps} />}
                        {isComplaintSelected && <ComplaintStepper {...contentProps} />}
                        {isExchangeSelected && <ExchangeStepper {...contentProps} />}
                        {!returnMethod && <MethodSelector {...props} setReturnMethod={setReturnMethod} />}
                    </div>
                )}
            </TurnrModal>
        </>
    );
}
